export default __webpack_public_path__ + "static/media/ArrowDown.e2b494db.svg";